import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rheology-vertical',
  standalone: false,
  templateUrl: './rheology-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class RheologyVerticalComponent {
@Input() rheologyTest:any
}
